var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTier2Img(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 350,
    height: 350,
    viewBox: "0 0 350 350",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M336.21 3.06413C342.633 1.637 348.363 7.36697 346.936 13.7902L311.551 173.05C311.266 174.335 311.266 175.666 311.551 176.95L346.936 336.21C348.363 342.634 342.633 348.363 336.21 346.936L176.95 311.552C175.666 311.266 174.334 311.266 173.05 311.552L13.79 346.936C7.36672 348.363 1.63676 342.634 3.06389 336.21L38.4487 176.95C38.7341 175.666 38.7341 174.335 38.4487 173.05L3.06389 13.7902C1.63676 7.36696 7.36673 1.637 13.79 3.06413L173.05 38.449C174.334 38.7343 175.666 38.7343 176.95 38.449L336.21 3.06413Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.26,
    d: "M175.091 101.12L211.258 139.08L249.218 175.247L211.258 211.414L175.091 249.374L138.924 211.414L100.964 175.247L138.924 139.08L175.091 101.12Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.36 82.0519C176.663 79.7033 173.337 79.7033 172.64 82.0519L147.718 166.075L111.333 259.08C110.423 261.406 113.156 263.452 115.132 261.923L173.494 216.767C174.381 216.081 175.619 216.081 176.506 216.767L234.868 261.923C236.844 263.452 239.577 261.406 238.667 259.08L202.282 166.075L177.36 82.0519Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.951 189.801L95.2219 246.251",
    stroke: "#C4C4C4",
    strokeWidth: 9.19964,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTier2Img);
export default __webpack_public_path__ + "static/media/tier-2-img.086023622ce89d00c7ad4feea9362f82.svg";
export { ForwardRef as ReactComponent };